import clsx from "clsx";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  NotificationType,
} from "@transfr-inc/dashboard-components";
import { getLearnerTerm } from "@transfr-inc/dashboard-components/constants";
import { Button } from "@transfr-inc/dashboard-components/forms";

import { useContainer } from "@contexts/container-context";
import { useNotificationContext } from "@contexts/notification-context";

import "./delete-modal.scss";

export const BulkArchiveUserModal = ({
  open,
  onCancel,
  className,
  learners,
  onArchived,
  orgCode,
}) => {
  const learnerPlural = getLearnerTerm({ lowercase: true, plural: true });
  const titleSingular = getLearnerTerm();
  const titlePlural = getLearnerTerm({ plural: true });

  const { userService } = useContainer();
  const { addNotification } = useNotificationContext();

  const { handleSubmit, reset } = useForm({
    defaultValues: { ...learners },
  });

  useEffect(() => {
    reset(learners);
  }, [learners]);

  const getContent = (list) => {
    return list.length == 1 ? (
      <div className="delete-content">
        Are you sure you would like to archive{" "}
        <b>
          {list[0].firstName} {list[0].lastName}
        </b>
        ? The data for archived trainees will remain unchanged.
      </div>
    ) : (
      <div className="delete-content">
        Are you sure you would like to archive <b>{list.length}</b>{" "}
        {learnerPlural}? The data for archived trainees will remain unchanged.
      </div>
    );
  };

  const submitForm = async (values) => {
    try {
      const userIds = values.map((x) => x.userId);
      const archiveOrgCode = orgCode ?? values[0]?.organizationCode;

      await userService.archiveUsers(userIds, archiveOrgCode);
      onArchived?.(userIds);

      addNotification({
        type: NotificationType.success,
        icon: ["fa-solid", "circle-check"],
        message:
          values.length > 1 ? (
            <div>
              <b>{values.length}</b> {learnerPlural} have been archived.
            </div>
          ) : (
            <div>
              <b>
                {values[0].firstName} {values[0].lastName}
              </b>{" "}
              has been archived.
            </div>
          ),
      });
    } catch (error) {
      console.log(error);
      console.trace();
      addNotification({
        type: NotificationType.error,
        message: "Something went wrong",
      });
    } finally {
      onCancel?.();
    }
  };

  const onClick = (_, e) => {
    handleSubmit(submitForm)(e);
  };

  return (
    <div className={clsx("delete-modal-container", className)}>
      <Modal modalClassName={"delete-modal"} open={open} onClose={onCancel}>
        <ModalHeader
          className="red-icon"
          icon={["fa-light", "box-archive"]}
          title={`Archive ${learners.length > 1 ? titlePlural : titleSingular}`}
        />
        <ModalBody className="delete-body">{getContent(learners)}</ModalBody>
        <ModalFooter>
          <Button onClick={onCancel}>No, Cancel</Button>
          <Button destructive onClick={onClick}>
            {learners.length > 1
              ? `Yes, Archive ${titlePlural}`
              : `Yes, Archive`}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};
